export default __webpack_public_path__ + "static/media/crio.a2e716e4.svg";